import { render, staticRenderFns } from "./lawPop.vue?vue&type=template&id=28cd5427"
import script from "./lawPop.vue?vue&type=script&lang=js"
export * from "./lawPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28cd5427')) {
      api.createRecord('28cd5427', component.options)
    } else {
      api.reload('28cd5427', component.options)
    }
    module.hot.accept("./lawPop.vue?vue&type=template&id=28cd5427", function () {
      api.rerender('28cd5427', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/chm/law/lawPop.vue"
export default component.exports